var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#6C00F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1835 4.93701C11.3254 4.93705 11.4517 4.99025 11.5634 5.09912C11.6749 5.21081 11.7303 5.33779 11.7303 5.48096C11.7303 5.62426 11.675 5.752 11.5634 5.86377L7.05066 10.3804C6.94192 10.489 6.81434 10.5424 6.66687 10.5425C6.51921 10.5425 6.39094 10.4892 6.2821 10.3804L4.4325 8.52979H4.43152C4.32304 8.41827 4.27039 8.29107 4.27039 8.14795C4.27039 8.04039 4.30053 7.94172 4.36316 7.85205L4.4364 7.76611C4.54801 7.65718 4.67491 7.60313 4.81824 7.60303C4.96174 7.60303 5.08933 7.65706 5.20105 7.76611L6.64929 9.21826L6.66687 9.23584L10.8036 5.09912L10.8026 5.09814C10.9143 4.98933 11.0415 4.93701 11.1835 4.93701Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4da3f71512f25152051fa1d2b8a55cde.svg";
export { ForwardRef as ReactComponent };